import { Component, OnInit, Input } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { CampaignService } from '../../services/campaign.service';
import { Campaign } from '../../shared/campaign/campaign.model';
import { ClientService } from '../../services/client.service';

@Component({
  selector: 'app-campaigns',
  templateUrl: './campaigns.component.html',
  styleUrls: ['./campaigns.component.css']
})
export class CampaignsComponent implements OnInit {
  clientId: string;
  campaign: Campaign = new Campaign();
  event:any;
  clients:any;
  mode: string;
  campaignId: string = "";
  public data: any;
  public rowsOnPage: number = 10;
  public filterQuery: string = "";
  public sortBy: string = "";
  public sortOrder: string = "desc";

  constructor(public campaignService: CampaignService, public authService: AuthService, public clientService: ClientService) {
    this.clientId = JSON.parse(localStorage.getItem('user')).data.client;
  }

  getAll() {
    this.campaignService.getAll()
      .subscribe((data:any)=> {
        this.data = data.data;
      }, (err:any) => {
        if (err.status === 401) {
          this.authService.logout();
        }
      });
  }

  getCampaign(id) {
    this.campaignService.getCampaign(id)
      .subscribe((data:any)=> {
        this.campaign = data.data;
        this.campaign.startDate = this.decodeDate(this.campaign.startDate);
      }, (err:any) => {
        if (err.status === 401) {
          this.authService.logout();
        }
      });
  }

  getCampaignByClient(id) {
    console.log("Id usuario ", id)
    this.campaignService.getCampaignByClient(id)
      .subscribe((data:any)=> {
        console.log("*** data ***", data);
        this.data = data.data;
      });
  }

  save() {
		const body = {
			name: this.campaign.name,
			description: this.campaign.description,
			amount: this.campaign.amount,
			goal: this.campaign.goal,
			cpl: this.campaign.cpl,
      client: this.clientId,
      startDate: this.getDate(this.campaign.startDate)
		}
    
    if (this.campaignId !== "") {
      this.campaignService.update(body, this.campaignId)
        .subscribe((data:any) => {
          console.log(data);
          if (data.success === true) {
            this.getAll();
            document.querySelector("#"+this.event).classList.remove('md-show');
          } else {}
        })
    } else {
      this.campaignService.create(body)
        .subscribe((data:any) => {
          console.log(data);
          if (data.success === true) {
            this.getAll();
            document.querySelector("#"+this.event).classList.remove('md-show');
          } else {}
        })
    }
  }

  delete(id) {
    this.campaignService.delete(id)
      .subscribe((data:any) => {
        if (data.success === true) {
          this.getAll();
        }
      })
  }

  getDate(date) {
    return new Date(date.year, date.month, date.day);
  }
  
  decodeDate(date) {
    let newDate = new Date(date);

    return {
      year: newDate.getFullYear(),
      month: newDate.getMonth() + 1,
      day: newDate.getDate()
    };
  }

  // SE EJECUTA AL CARGAR EL COMPONENTE
  ngOnInit() {
    this.getCampaignByClient(this.clientId);
  }

  openMyModal(event, campaignId=null) {
    document.querySelector("#"+event).classList.add('md-show');
    this.event = event;

    if (campaignId !== null) {
      this.getCampaign(campaignId);
      this.campaignId = campaignId;
    }
  }

  closeMyModal(event) {
    ((event.target.parentElement.parentElement).parentElement).classList.remove('md-show');
  }

}



// WEBPACK FOOTER //
// ./src/app/components/campaigns/campaigns.component.ts